import { useContext } from "react";
import { FlowLayoutContext } from "../FlowLayout";

/**
 * Access the flow layout context from a component within the layout.
 */
export function useFlowLayout() {
  return useContext(FlowLayoutContext);
}
